import React, { useEffect } from 'react';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { defineMessages, useIntl } from 'react-intl';
import map from 'lodash/map';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import {
  applyBlockDefaults,
  getBlocks,
  hasBlocksData,
} from '@plone/volto/helpers/Blocks/Blocks';
import StyleWrapper from '@plone/volto/components/manage/Blocks/Block/StyleWrapper';
import config from '@plone/volto/registry';
import ViewDefaultBlock from '@plone/volto/components/manage/Blocks/Block/DefaultView';
/* custom code start: absolute import, the shadow lives outside the core directory */
import RenderEmptyBlock from '@plone/volto/components/theme/View/RenderEmptyBlock';
import { useDispatch, useSelector } from 'react-redux';
import { getHiddenBlockTypes } from '../../../../../actions';
/* custom code end */

const messages = defineMessages({
  unknownBlock: {
    id: 'Unknown Block',
    defaultMessage: 'Unknown Block {block}',
  },
  invalidBlock: {
    id: 'Invalid Block',
    defaultMessage: 'Invalid block - Will be removed on saving',
  },
});

/* custom code start */
const defaultBlockTypes = [];

const isWikiTitleBlock = (content, blockType) =>
  content['@type'] === 'Wiki' && blockType === 'title';

const checkTypeExist = (items, type) => {
  if (Array.isArray(items)) {
    for (const item of items) {
      if (checkTypeExist(item, type)) {
        return true;
      }
    }
  } else if (typeof items === 'object') {
    for (const prop in items) {
      if (checkTypeExist(items[prop], type)) {
        return true;
      }
    }
  } else if (items === type) {
    return true;
  }
  return false;
};
/* custom code end */

const RenderBlocks = (props) => {
  const { blockWrapperTag, content, location, isContainer, metadata } = props;
  const intl = useIntl();
  const blocksConfig = props.blocksConfig || config.blocks.blocksConfig;
  const CustomTag = props.as || React.Fragment;

  const blockList = getBlocks(content);

  /* custom code start */
  const dispatch = useDispatch();
  const hiddenBlockTypes = useSelector(
    (state) => state.hiddenblocktypes?.items || defaultBlockTypes,
  );

  const showBlock = (blockData, type) => {
    if (type === 'columnsBlock') {
      return checkTypeExist(blockData, type);
    }
    return hiddenBlockTypes && hiddenBlockTypes.includes
      ? hiddenBlockTypes.includes(type)
      : false;
  };

  useEffect(() => {
    dispatch(getHiddenBlockTypes());
  }, [dispatch]);
  /* custom code end */

  return hasBlocksData(content) ? (
    <CustomTag>
      {map(blockList, ([block, rawBlockData]) => {
        const Block =
          blocksConfig[rawBlockData?.['@type']]?.view || ViewDefaultBlock;

        const blockData = applyBlockDefaults({
          data: rawBlockData,
          intl,
          metadata,
          properties: content,
        });

        if (rawBlockData?.['@type'] === 'empty') {
          return (
            <MaybeWrap
              key={block}
              condition={blockWrapperTag}
              as={blockWrapperTag}
            >
              <RenderEmptyBlock />
            </MaybeWrap>
          );
        }

        /* custom code start */
        if (isWikiTitleBlock(content, rawBlockData?.['@type'])) {
          return (
            <MaybeWrap
              key={block}
              condition={blockWrapperTag}
              as={blockWrapperTag}
            >
              <div />
            </MaybeWrap>
          );
        }
        /* custom code end */

        if (Block) {
          return (
            <MaybeWrap
              key={block}
              condition={blockWrapperTag}
              as={blockWrapperTag}
            >
              <StyleWrapper
                key={block}
                {...props}
                id={block}
                block={block}
                data={blockData}
                isContainer={isContainer}
              >
                {/* custom code start */}
                {(hiddenBlockTypes && hiddenBlockTypes.length === 0) ||
                showBlock(blockData, blockData['@type']) ? (
                  <Block
                    id={block}
                    metadata={metadata}
                    properties={content}
                    data={blockData}
                    path={getBaseUrl(location?.pathname || '')}
                    blocksConfig={blocksConfig}
                  />
                ) : (
                  <></>
                )}
                {/* custom code end */}
              </StyleWrapper>
            </MaybeWrap>
          );
        }

        if (blockData) {
          return (
            <div key={block}>
              {intl.formatMessage(messages.unknownBlock, {
                block: rawBlockData?.['@type'],
              })}
            </div>
          );
        }

        return (
          <div key={block}>{intl.formatMessage(messages.invalidBlock)}</div>
        );
      })}
    </CustomTag>
  ) : (
    ''
  );
};

export default RenderBlocks;
